import { Injectable } from '@angular/core';

import { Actions, ofType, createEffect } from '@ngrx/effects';
import * as AuthorizationActions from '../actions/authorization.action';

import { map } from 'rxjs/operators';

@Injectable()
export class AuthorizationEffects {
  public navigate$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AuthorizationActions.USER_SIGNED_IN),
        map((): void => {
        })
      ),
    { dispatch: false }
  );
    
  constructor(
    private readonly actions$: Actions,
  ) {}

}